import dayjs from "dayjs";
import type { Person } from "@/services/api";

export const getLastModifiedPersons = ({
  count,
  persons,
}: {
  count: number;
  persons: Person[];
}): Person[] => {
  const rest = [...persons];

  const sliceCount = count === 0 ? 1 : count;

  return rest
    .sort((a, b) => {
      return dayjs(a.lastModifiedDate).isAfter(dayjs(b.lastModifiedDate)) ? -1 : 1;
    })
    ?.slice(0, sliceCount);
};
